import { render } from "./ConfiguracionSri.vue?vue&type=template&id=4889df4c"
import script from "./ConfiguracionSri.vue?vue&type=script&lang=js"
export * from "./ConfiguracionSri.vue?vue&type=script&lang=js"

import "./ConfiguracionSri.vue?vue&type=style&index=0&id=4889df4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__